export type Step = 'form' | 'confirm' | 'avcheck';

export const STEP_ORDER: Step[] = ['form', 'confirm', 'avcheck'];

export function stepIndex(s: Step): number {
  return STEP_ORDER.indexOf(s);
}
